import { Component, OnInit, Input } from '@angular/core';

import { UXBlocksGroup } from '../../../core/models/ux-page';

@Component({
  selector: 'app-blocks-group',
  templateUrl: './blocks-group.component.html',
  styleUrls: ['./blocks-group.component.scss']
})
export class BlocksGroupComponent implements OnInit {
  @Input() blocksGroup: UXBlocksGroup

  constructor() { }

  ngOnInit() {
  }

  get code(): string {
    if (this.blocksGroup) {
      return this.blocksGroup.code
    }
  }

  get hasBlocks(): boolean {
    if (this.blocksGroup && this.blocksGroup.blocks && this.blocksGroup.blocks.length) {
      return true
    }
    return false
  }

}
